var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import * as qs from 'qs';
import { TranslateService } from "app/translate/translate.service";
import { AlertComponent } from "app/views/modal/alert.component";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HelperService } from "app/lib/helper.service";
import { ChartParams } from "app/views/chart/chart.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { ModalService } from "app/views/modal/base_modal.component";
import { UserService } from "../user.service";
var RegDayComponent = /** @class */ (function (_super) {
    __extends(RegDayComponent, _super);
    function RegDayComponent(document, eventsService, helper, activatedRoute, translate, router, modalService, filter, userService) {
        var _this = _super.call(this, eventsService, userService, activatedRoute, filter, translate) || this;
        _this.document = document;
        _this.eventsService = eventsService;
        _this.helper = helper;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.userService = userService;
        _this.stats = [];
        _this.totalLoader = false;
        _this.paginationLoader = false;
        _this.statsLoader = false;
        _this.chartData = new ChartParams();
        _this.dontLoad = {};
        _this.addFilterParams = {
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated', 'dateTo', 'datePublished'],
            isRegDay: true,
            userType: 'user',
            dateType: 'dateCreated'
        };
        _this.lpTracker = false;
        _this.lpTrackerData = {
            active: {
                loader: false,
                count: null
            },
            fallen: {
                loader: false,
                count: null
            }
        };
        _this.subjectsLoaderMap = {};
        _this.chartData.setOptions({
            showLabels: [
                'countReg', 'siteCount', 'usersWithSite', 'publishedSites', 'uncomplitedSites', 'published', 'publishedFirst'
            ],
            names: {
                'countReg': _this.translate.__A('users.reg_day.countReg'),
                'siteCount': _this.translate.__A('users.reg_day.created sites'),
                'createdSites': _this.translate.__A('users.reg_day.created sites by period'),
                'usersWithSite': _this.translate.__A('users.reg_day.usersWithSite'),
                'publishedSites': _this.translate.__A('users.reg_day.publishedSites'),
                'uncomplitedSites': _this.translate.__A('users.reg_day.uncomplitedSites'),
                'published': _this.translate.__A('users.reg_day.published'),
                'publishedAction': _this.translate.__A('users.reg_day.publishedAction'),
                'publishedFirst': _this.translate.__A('users.reg_day.publishedFirst')
            }
        });
        return _this;
    }
    RegDayComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var host;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        host = document.location.hostname;
                        if (host === 'constructor.lptracker.ru' || host === '8-stat-dev.ukit.com' || host === 'stat-dev.ukit.com') {
                            this.lpTracker = true;
                        }
                        this.lpTrackerData.active.count = null;
                        this.lpTrackerData.fallen.count = null;
                        return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getTotal()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для графика
    RegDayComponent.prototype.getChart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.chart) {
                            return [2 /*return*/, true];
                        }
                        this.chartData.showLoader();
                        return [4 /*yield*/, this.userService.reg_day.chart(this.filter.getCopyFilterParams(params)).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.chartData.data = charts;
                        this.chartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для тотала
    RegDayComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.dontLoad.total) {
                            return [2 /*return*/, true];
                        }
                        this.total = null;
                        if (!this.filter.filterParams.isShowRegDayTotal) {
                            return [2 /*return*/, true];
                        }
                        this.totalLoader = true;
                        _a = this;
                        return [4 /*yield*/, this.userService.reg_day.total(this.filter.filterParams).toPromise()];
                    case 1:
                        _a.total = _b.sent();
                        this.totalLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для пагинации
    RegDayComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!this.dontLoad.pagination) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        if (!(this.filter.filterParams.period !== 'summary')) return [3 /*break*/, 4];
                        this.paginationLoader = true;
                        return [4 /*yield*/, this.userService.reg_day.pagination(this.filter.filterParams).toPromise()];
                    case 3:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.userService.reg_day.getRealFullRoute());
                        }
                        this.paginationLoader = false;
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.getStats()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для stats
    RegDayComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.userService.reg_day.stats(this.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.stats = stats;
                        me.stats.forEach(function (stat) {
                            var dates = me.helper.getTimeAsIntervals({
                                timestamp: stat.timestamp,
                                period: me.filter.filterParams.period
                            });
                            if (dates.length == 2) {
                                stat.currentPeriod = dates[0] + '-' + dates[1];
                            }
                            else {
                                stat.currentPeriod = dates[0];
                            }
                            stat.day = new Date(stat.timestamp).getDay();
                            if (stat.currentPeriod == '') {
                                stat.currentPeriod = 'summary';
                            }
                        });
                        me.statsLoader = false;
                        me.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    // Клик по пагинации
    RegDayComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    total: true,
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    // Кнопка - Скачать пользователей с приложениями
    RegDayComponent.prototype.downloadButton = function () {
        window.location.href = this.userService.reg_day.downloadFileRoute(this.filter.filterParams);
        this.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    RegDayComponent.prototype.showSubjectList = function (stat) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(stat.subject.length === 0)) return [3 /*break*/, 2];
                        this.subjectsLoaderMap[stat.currentPeriod] = true;
                        _a = stat;
                        return [4 /*yield*/, this.userService.reg_day.get(__assign({}, this.filter.filterParams, { groupDate: stat.groupDate }), 'subject').toPromise()];
                    case 1:
                        _a.subject = _b.sent();
                        delete this.subjectsLoaderMap[stat.currentPeriod];
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RegDayComponent.prototype.getLpTrackerData = function (stat, type) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.lpTrackerData[type].loader = true;
                        _a = this.lpTrackerData[type];
                        return [4 /*yield*/, this.userService.reg_day.get(this.filter.getCopyFilterParams({
                                lpType: type,
                                groupDate: stat.groupDate
                            }), 'lptracker').toPromise()];
                    case 1:
                        _a.count = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        this.lpTrackerData[type].loader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return RegDayComponent;
}(BaseComponent));
export { RegDayComponent };
